import { defaultState } from '@/enums/signup'

export default () => ({
  ...defaultState
})
